import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ListTodo, AlertTriangle, Calendar } from "lucide-react";
import { createTaskApi } from "../api/taskApi";
import { computeTaskStats } from "../utils/taskStats";

const TaskDashboardSummary = ({ apiUrl, getToken, className = "" }) => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        const api = createTaskApi({ role: "admin", apiUrl, getToken });
        api.fetchTasks()
            .then((tasks) => {
                if (!cancelled) setStats(computeTaskStats(tasks));
            })
            .catch(() => {
                if (!cancelled) setStats(null);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, [apiUrl, getToken]);

    if (loading) {
        return (
            <div
                className={`rounded-xl border border-line bg-surface-2 p-4 animate-pulse h-24 ${className}`}
            />
        );
    }

    if (!stats) return null;

    const items = [
        {
            label: "Due today",
            value: stats.dueToday,
            to: "/tasks?filter=today",
            icon: Calendar,
            accent: "text-info",
        },
        {
            label: "Overdue",
            value: stats.overdue,
            to: "/tasks?filter=overdue",
            icon: AlertTriangle,
            accent: "text-error",
        },
        {
            label: "Active",
            value: stats.active,
            to: "/tasks?filter=active",
            icon: ListTodo,
            accent: "text-primary",
        },
    ];

    return (
        <div
            className={`rounded-xl border border-line bg-gradient-to-br from-surface-2 to-primary/5 p-4 ${className}`}
        >
            <div className="flex items-center justify-between mb-3">
                <h3 className="text-sm font-semibold text-ink flex items-center gap-2">
                    <ListTodo size={16} className="text-primary" />
                    Team tasks
                </h3>
                <Link
                    to="/tasks"
                    className="text-xs font-medium text-primary hover:underline"
                >
                    View all
                </Link>
            </div>
            <div className="grid grid-cols-3 gap-2">
                {items.map(({ label, value, to, icon: Icon, accent }) => (
                    <Link
                        key={label}
                        to={to}
                        className="rounded-lg border border-line bg-surface p-2.5 hover:border-primary/40 hover:bg-surface-2 transition"
                    >
                        <div className="flex items-center gap-1 text-[10px] uppercase tracking-wide text-ink-muted font-semibold">
                            <Icon size={12} className={accent} />
                            {label}
                        </div>
                        <p className={`text-xl font-bold mt-0.5 ${accent}`}>{value}</p>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default TaskDashboardSummary;
